import React from 'react';
import Main from './Componentes/Main';
import './Componentes/style.css';


function App() {
  return (
    <>
      <Main/>
   
    </>
  );
}

export default App;